import { render, staticRenderFns } from "./lxcg.vue?vue&type=template&id=35adae4d&scoped=true&"
import script from "./lxcg.vue?vue&type=script&lang=js&"
export * from "./lxcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adae4d",
  null
  
)

export default component.exports